const EditProfile = () => import(/* webpackChunkName: "edit-profile" */ '@/views/profile/EditProfile');

const meta = (data = {}) => ({
    title: 'Profile',
    auth: true,
    ...data,
});

export default [{
    path: 'profile',
    name: 'EditProfile',
    component: EditProfile,
    props: true,
    meta: meta({
        ignorePrivilege: true,
    }),
}];
